module.exports = __webpack_public_path__ + "static/media/chrysochraon_dispar_007_APA.ea15bfad.png";